import {LineTls} from '../tools/LineTls';
import {Tls} from '../tools/Tls';
import * as L from 'leaflet'

const LineDrawer = {


    draw(mymap, lineRow) {

        var Detail = 0;
        if(lineRow.cond_type.search("خ") < 0 && lineRow.cond_type.search("س") < 0) return null;
        var strPoints = lineRow["_lines"];
        
        
        var lLable = Math.round(lineRow.real_length*10)/10 + 'm';
        // if it is cable not length Label
        // if (lineRow.cond_type.search('ابل') > 0) {
        //     lLable = '';
        // }

        // line Styles
        var lineStyle = LineTls.getLineStyle(lineRow);



        
        var tmp11 =     L.polyline(Tls.str2path(strPoints), LineTls.getLineTmpStyle()).addTo(mymap);
        // draw Polyline to map
        var tmp = L.polyline(Tls.str2path(strPoints), lineStyle).addTo(mymap);

        tmp.myId = lineRow._id;
        tmp.myType = 'lv_line';

        tmp.bindPopup(LineTls.getInfo(lineRow));

        // Text styles
        // TODO save style to database
        // TODO save labels to database
        
        
        // '3×25+2×16'



        // draw line
        // label = '30m';
        // var str ='298985.01710000,3797146.81140000;298984.78080000,3797146.73900000;298960.50770000,3797139.30590000';
        // L.polyline(Tls.str2path(strPoints)).addTo(mymap).setText(label,{repeat:false, center:true, below:true, offset:0,orientation: 'flip',attributes :""});  
        // L.polyline(Tls.str2path(strPoints)).addTo(mymap).setText(label,{repeat:false, center:true, below:true, offset:-5});  
        // L.polyline(Tls.str2path(strPoints)).addTo(mymap).setText(label,{ offset:0,orientation: '0',attributes :""});  
        // L.polyline(Tls.str2path(strPoints)).addTo(mymap).bindTooltip(label).openTooltip();




        // TODO can limit labels
        
        // conductor type
        var cType = LineTls.convertRow2Cond(lineRow);
        var attrTextC = { fill: '#333', 'font-family': 'Vazir', 'font-size': '10' };
        if (cType != '' && Detail !=1)
            tmp.setText(cType, { repeat: false, center: true, offset: -5, attributes: attrTextC });

            
     
   // Length
   var attrTextM = { fill: '#333', 'font-family': 'Vazir', 'font-size': '10', 'background-color': '#fff' };
   if (lLable != '' && Detail !=1)
   tmp11.setText(lLable, { repeat: false, center: true, offset: 12, attributes: attrTextM });


      
        // // extra label
        // var harim = lineRow.harim;
        // if (harim != '')
        //     tmp.setText(harim.toString(), { repeat: false, center: true, offset: -20, attributes: attrTextC });

        // tmp.setText(cType+lLable, { repeat: false, center: true, offset: -5, attributes: attrTextC });
        // tmp.setText(cType, { repeat: false, offset: -5, attributes: attrTextC });
        // lineRow.L_LENGTH


        // if(lineRow.HARIM){
        //     tmp.bindPopup(lineRow.HARIM).openOn(mymap);
        // }


        // tmp.enableEdit();
        // https://github.com/Leaflet/Leaflet.Editable
        // map.editTools.startPolyline();
        return tmp;
     
    },




};

export {LineDrawer}